module.exports = __webpack_public_path__ + "static/rearrange-7133d20ea4b1d2a72d3be75999d0ec25.mp4";